import { useSelector } from 'react-redux';

import { Skeleton } from 'antd';

import {
  selectDictionary,
  selectIsDictionariesLoading
} from 'features/dictionaries/dictionariesSelectors';

import formatJobSalaryDisplay from 'utils/formatting/formatJobSalaryDisplay';
import { isNil } from 'utils/isNil';

import { Job, JobSalaryDisplayFields } from 'types/jobs';

import { Dictionaries } from 'constants/enums';
import { FALLBACK_VALUE } from 'constants/uiSettings';

interface SalaryProps {
  job: JobSalaryDisplayFields & Pick<Job, 'payrollRates'>;
}

const formatPayrollRateLabel = (rate: string): string => {
  if (!rate) {
    return '';
  }

  return ` ${rate.charAt(0).toLowerCase()}${rate.slice(1)}`;
};

const Salary = ({ job }: SalaryProps) => {
  const payrollRatesDict = useSelector(
    selectDictionary(Dictionaries.PayrollRates)
  );
  const isDictionariesLoading = useSelector(selectIsDictionariesLoading);

  const rate =
    !isNil(job.payrollRates) && payrollRatesDict.length
      ? (payrollRatesDict.find((item) => item.value === job.payrollRates)
          ?.label as string)
      : '';

  const salaryDisplay = formatJobSalaryDisplay(job);

  if (salaryDisplay === FALLBACK_VALUE) {
    return <div>{FALLBACK_VALUE}</div>;
  }

  if (job.payrollRates && isDictionariesLoading) {
    return <Skeleton.Input active size="small" />;
  }

  const frequency = formatPayrollRateLabel(rate);

  return <div>{`${salaryDisplay}${frequency}`}</div>;
};

export default Salary;
